import React, {SVGProps} from 'react';

import {ReactComponent} from '../../assets/svg/settings_grey.svg';

export default (props: SVGProps<any>): JSX.Element => <ReactComponent {...props} />;
